import { render, staticRenderFns } from "./ErrWord.vue?vue&type=template&id=19f6678c&scoped=true&"
import script from "./ErrWord.vue?vue&type=script&lang=js&"
export * from "./ErrWord.vue?vue&type=script&lang=js&"
import style0 from "./ErrWord.vue?vue&type=style&index=0&id=19f6678c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6678c",
  null
  
)

export default component.exports